import moment from 'moment';

// accessing and adding localstorage variables
import { colorsList, dateFormats, appConstant, apiUrl } from '@constants';

import { createBrowserHistory } from 'history';
import Axios from 'axios';
export const history = createBrowserHistory();

export const getSessionVariable = (key) => JSON.parse(sessionStorage.getItem(key));
export const setSessionVariable = (key, value) => sessionStorage.setItem(key, JSON.stringify(value));
export const removeSessionVariable = (key) => sessionStorage.removeItem(key);

export const getLocalvariable = (key) => JSON.parse(localStorage.getItem(key));
export const setLocalvariable = (key, value) => localStorage.setItem(key, JSON.stringify(value));
export const removeLocalvariable = (key) => localStorage.removeItem(key);

export const encryptCompanyId = (id) => {
	let uri = appConstant.domain + apiUrl.ENCRYPT + id
	return Axios.get(uri)
		.then((res) => {
			return res && res.data && res.data.messages ? res.data.messages : null
		})
}

export const decryptCompanyId = (id) => {
	let uri = appConstant.domain + apiUrl.DECRYPT + id
	return Axios.get(uri)
		.then((res) => {
			return res && res.data && res.data.messages ? res.data.messages : null
		})
}

export const devlog = (log) => {
	if (process.env.NODE_ENV !== 'production') {
		console.log(log);
	}
};
export const getAuthKey = () => {
	return (JSON.parse(localStorage.getItem('authKey')) && atob(JSON.parse(localStorage.getItem('authKey')))) || null;
};
export const getAuthToken = () => {
	return (JSON.parse(localStorage.getItem('authToken')) && atob(JSON.parse(localStorage.getItem('authToken')))) || null;
};
export const getKeyAndToken = () => {
	const authKey = (JSON.parse(localStorage.getItem('authKey')) && atob(JSON.parse(localStorage.getItem('authKey')))) || null;
	const authToken = (JSON.parse(localStorage.getItem('authToken')) && atob(JSON.parse(localStorage.getItem('authToken')))) || null;
	return { authKey, authToken };
};

export const isAuth = (permissions, userRole) => {
	return permissions.includes(userRole);
};
export const handleErrorMessage = (err) =>
	err.toString(err) === 'Error: Request failed with status code 400' ? appConstant.userNotExist : 'Something went wrong';
export const getRandomColors = () => {
	return colorsList[Math.floor(Math.random() * colorsList.length)];
};

export const checkValue = (value) => {
	if (typeof value !== 'undefined' && value) {
		//deal with value'
		return value;
	}
};
export const checkByNested = (obj, key) => {
	return key.split('.').reduce(function (o, x) {
		return typeof o == 'undefined' || o === null ? o : o[x];
	}, obj);
};
export const activeMenu = (menuRoutes, path) => menuRoutes.findIndex((menu) => menu.route === path);
export const replaceNullAndSpace = (value) => {
	if (!value || value === '') return '-';
	return value;
};
export const setStartDate = (value) => {
	var date = new Date();
	switch (value) {
		case 'LAST':
			date = new Date().getDate();
			return new Date().setDate(date - 7);
		case 'LASTFOUR':
			date = new Date().getDate();
			return new Date().setDate(date - 4);
		case 'YEST':
			date = new Date().getDate();
			return new Date().setDate(date - 1);
		case 'THIS_WEEK':
			var d = new Date();
			var day = d.getDay(),
				diff = d.getDate() - day + (day === 0 ? -6 : 1);
			return new Date(d.setDate(diff));
		case 'THIS_MONTH':
			date = new Date();
			return new Date(date.getFullYear(), date.getMonth(), 1);
		default:
			break;
	}
};
export const daysBetweenTwoDates = (start, end) => {
	var start = moment(start, dateFormats.MM_DD_YYYY);
	var end = moment(end, dateFormats.MM_DD_YYYY);

	//Difference in number of days
	return Math.abs(moment.duration(start.diff(end)).asDays());
};
export const disableFutureDate = (disableFutureDate) => {
	return disableFutureDate >= new Date();
};

export const constructTrackingStrings = (sourceValues) =>
	Object.entries(sourceValues)
		.map(([key, value]) => {
			return value && `&${value}=[${value}]`;
		})
		.join('');
